// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"212":"PTransferList","447":"PTransferActivityList","993":"PTransferBuilderNew"}[chunkId] + "." + {"212":"70f33263","447":"b11c3a33","993":"eee5ecc1"}[chunkId] + ".css";
};